// removed by extract-text-webpack-plugin
module.exports = {"container":"LayoutAdmin__container__1aDu9","sideMenu":"LayoutAdmin__sideMenu__11u--","header":"LayoutAdmin__header__3IRMN","mainContent":"LayoutAdmin__mainContent__2dwC0","titleSection":"LayoutAdmin__titleSection__gLnIu","loader":"LayoutAdmin__loader__2gz2e","load1":"LayoutAdmin__load1__18ELh"};


//////////////////
// WEBPACK FOOTER
// ./src/HOCs/LayoutAdmin/LayoutAdmin.css
// module id = 560
// module chunks = 0